var SetIntervalMixin = {
  componentWillMount: function() {
    this.intervals = []
  },
  setInterval: function() {
    this.intervals.push(setInterval.apply(null, arguments))
  },
  componentWillUnmount: function() {
    this.intervals.forEach(clearInterval)
  }
}

module.exports = SetIntervalMixin



// WEBPACK FOOTER //
// ./src/mixins/interval.js